import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hb9 from '../components/Hb9';

function Training() {
  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Archivo+Black&family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet" />
      <style>{`
        body {
          font-family: 'Poppins', sans-serif;
        }
        .font-archivo-black {
          font-family: 'Archivo Black', sans-serif;
        }
        .font-poppins {
          font-family: 'Poppins', sans-serif;
        }
      `}</style>

      <div className="font-poppins">
        <Header />
        
        {/* Hero Section */}
        <section className="bg-customBlue text-white p-6 lg:p-24 flex flex-col items-center text-center">
          <div className="max-w-4xl">
            <h1 className="font-archivo-black text-3xl lg:text-6xl font-bold mb-6 uppercase">
              Training & <span className="text-customY">Technology</span>
            </h1>
            <p className="text-lg lg:text-xl opacity-90 leading-relaxed">
              Empowering the next generation of professionals through strategic partnerships and industry-leading training solutions.
            </p>
          </div>
        </section>

        {/* Partnership Section */}
        <section className="py-20 px-6 lg:px-16 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-16">
              <div className="lg:w-1/2">
                <div className="inline-block bg-customY/10 text-customY px-4 py-2 rounded-full font-bold text-sm mb-6 uppercase tracking-widest">
                  Our Strategic Partner
                </div>
                <h2 className="font-archivo-black text-3xl lg:text-5xl text-customBlue mb-8 leading-tight">
                  Our Training & Technology Partner: <br />
                  <span className="text-customY">Air Bharath</span>
                </h2>
                <p className="text-gray-700 text-lg mb-8 leading-relaxed">
                  We have collaborated with <strong>Air Bharath</strong> to bring cutting-edge aviation excellence and technological integration to our recruitment and training ecosystem. Together, we ensure that candidates are not just job-ready, but industry-ready with the latest skills and technical know-how.
                </p>
                
                <div className="space-y-4 mb-10">
                  {[
                    "Industry-aligned curriculum",
                    "Advanced technological training tools",
                    "Aviation-specific skill development",
                    "Aviation Excellence and Certification",
                    "Real-world simulation and practice"
                  ].map((item, index) => (
                    <div key={index} className="flex items-center gap-4 text-gray-800 font-medium text-lg">
                      <div className="w-6 h-6 rounded-full bg-customBlue text-white flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path></svg>
                      </div>
                      {item}
                    </div>
                  ))}
                </div>

                <a 
                  href="https://airbharath.in/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-customBlue text-white px-10 py-5 font-bold rounded-xl shadow-2xl hover:bg-opacity-90 transition-all uppercase tracking-widest inline-flex items-center gap-3"
                >
                  Visit Air Bharath
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                </a>
              </div>
              
              <div className="lg:w-1/2 flex justify-center">
                <div className="relative group p-10 bg-gray-50 rounded-[4rem] border-2 border-dashed border-customBlue/20">
                  <div className="absolute inset-0 bg-customBlue/5 rounded-[4rem] scale-95 group-hover:scale-105 transition-transform duration-500"></div>
                  <img 
                    src="http://assets.airbharath.in/logo.webp" 
                    alt="Air Bharath Logo" 
                    className="relative z-10 w-full max-w-md h-auto object-contain drop-shadow-2xl transform transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-3xl shadow-2xl border border-customBlue/10 z-20 hidden md:block">
                     <div className="text-customBlue font-archivo-black text-2xl uppercase">Air Bharath</div>
                     <div className="text-customY font-bold tracking-[0.3em] text-xs">OFFICIAL PARTNER</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Training Features */}
        <section className="bg-customBlue py-20 px-6 lg:px-16 text-white text-center">
            <h2 className="font-archivo-black text-3xl lg:text-4xl mb-16 uppercase">
              Our Training Ecosystem
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
               <div className="bg-white/10 backdrop-blur-md p-10 rounded-3xl border border-white/20">
                  <div className="text-customY mb-6 flex justify-center">
                    <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path></svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4">Certified Curriculum</h3>
                  <p className="opacity-80">Our courses are designed in collaboration with industry experts to meet global standards.</p>
               </div>
               <div className="bg-white/10 backdrop-blur-md p-10 rounded-3xl border border-white/20">
                  <div className="text-customY mb-6 flex justify-center">
                    <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4">Tech-Enabled Learning</h3>
                  <p className="opacity-80">Using the latest educational technology to provide immersive and effective training experiences.</p>
               </div>
               <div className="bg-white/10 backdrop-blur-md p-10 rounded-3xl border border-white/20">
                  <div className="text-customY mb-6 flex justify-center">
                    <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4">Placement Support</h3>
                  <p className="opacity-80">Post-training, we leverage our recruitment networks to connect certified candidates with top employers.</p>
               </div>
            </div>
        </section>

        {/* Contact form section */}
        <Hb9 />
        
        <Footer />
      </div>
    </>
  );
}

export default Training;
